export default {
  lista: [],
  estaCarregando: false,
  paginaAtual: 1,
  order: '',
  direcao: '',
  totalItens: null,
  todosItensCarregados: false,
  itemSelecionadoID: null,
  itemSelecionado: {
    id: null,
    sigla: null,
    descricao: null,
    idioma: null,
    modalidade_turma: null,
    idade_minima: null,
    idade_maxima: null,
    servico: null,
    intensidade_regular: null,
    intensidade_semi_intensivo: null,
    intensidade_intensivo: null,
    intensidadeSelecionada: null,
    situacao: null
  }
}
